import { formatMoneyUnit, formatMoney, CHINESE_MONEY, THOUSANDS_SEPARATOR, truncateDecimals } from './tools'
import './input-money.scss'
import { decryptPlugin } from './decrypt-plugin'
const { DECRYPT_handleDecryptAction } = decryptPlugin()

const eventMap = {
  focus: 'focus',
  blur: 'blur',
  change: 'change',
  input: 'input',
  clear: 'clear'
}

export default {
  name: 'KyeInputMoney',
  props: {
    value: [String, Number],
    prependText: String,
    suffixText: {
      type: String,
      default: '元'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入金额'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'top-end'
    },
    offset: {
      type: Number,
      default: 0
    },
    isThousandPercent: Boolean,
    showUnit: {
      type: Boolean,
      default: true
    },
    showUnitPopover: {
      type: Boolean,
      default: true
    },
    popoverOptions: {
      type: Object,
      default: () => ({})
    },
    decimal: {
      type: Number,
      default: 2
    },
    customTranslateMoney: Function,
    min: {
      type: Number,
      default: -Infinity
    },
    minNumberCheck: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: Infinity
    },
    decryptOption: Object,
    disabledStep: Boolean,
    checkValueInChangeEvent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      unitText: '',
      formatMoneyText: '',
      moneyValue: '',
      isFocus: false,
      decrypting: true
    }
  },
  watch: {
    value: {
      handler(val) {
        this.formatMoney(val)
      },
      immediate: true
    },
    isThousandPercent() {
      this.formatMoney(this.moneyValue)
    }
  },
  computed: {
    showValue() {
      return this.isFocus ? this.moneyValue : this.formatMoneyText
    },
    inputType() {
      return this.isFocus ? 'number' : 'text'
    },
    showDecryptWrap () {
      return !!(this.decrypting && this.$props.decryptOption)
    }
  },
  render(h) {
    const { $slots, $props, $attrs = {} } = this
    const _internalOffset = $props.showUnit ? 40 : 10
    const elInputProps = {
      ...($attrs || {}),
      ...$props,
      value: this.showValue,
      type: this.inputType,
      readonly: this.showDecryptWrap || $attrs.readonly
    }
    const unitPopoverProps = {
      ...($props.popoverOptions || {}),
      content: this.unitText,
      value: $props.showUnitPopover && !!this.unitText,
      popperClass: [
        'kye-input-money-unit',
        this.unitText.length > 1 ? 'kye-input-money_t0' : '',
        this.$props.placement === 'top-end' ? 'kye-input-money-unit_top-end' : ''
      ].join(' '),
      trigger: 'manual',
      ref: 'unitRef',
      placement: $props.placement,
      transition: ' ',
      offset: [this.placement].includes('top-end') ? _internalOffset : $props.offset,
    }
    const ElInput = h('el-input',
      {
        props: { ...elInputProps },
        attrs: {
          ...($attrs || {}),
          placeholder: $props.disabled ? '' : $props.placeholder,
          // oninput: `if(value.indexOf('.')>0){value=value.slice(0, value.indexOf('.')+${$props.decimal + 1})}`,
          oninput: `
            const decimal = Number(${$props.decimal})
            if(value.indexOf('.')>0){
              if(decimal === 0){
                value=value.slice(0, value.indexOf('.'))
              }else{
                value=value.slice(0, value.indexOf('.')+ decimal + 1)
              }
            }
          `,
          title: ''
        },
        on: {
          focus: this.focus,
          blur: this.blur,
          change: this.handleChange,
          input: this.handleInput,
          clear: this.clear
        },
        nativeOn: {
          wheel: this.onWheel,
          keydown: this.onKeydown
        },
        ref: 'inputRef'
      },
      [
        renderPrependText(h, $props, $slots),
        renderSuffix(h, $props, $slots)
      ]
    )
    const ElInputContent = this.showDecryptWrap ? renderDecryptWrap(h, this, ElInput) : ElInput
    return h('div',
      {
        attrs: {
          'data-autocomplete': 'off'
        },
        class: 'kye-input-money',
        directives: [
          {
            name: 'popover',
            value: '',
            rawName: `v-popover:${unitPopoverProps.ref}`,
            arg: `${unitPopoverProps.ref}`,
            modifiers: undefined,
          }
        ],
      },
      [
        ElInputContent,
        h('el-popover', { props: { ...unitPopoverProps }, ref: unitPopoverProps.ref })
      ]
    )
  },
  methods: {
    formatMoney(value) {
      const { decimal, isThousandPercent, customTranslateMoney } = this.$props
      this.formatMoneyText = formatMoney({ value, type: isThousandPercent ? THOUSANDS_SEPARATOR : CHINESE_MONEY, decimal, customTranslateMoney })
      this.moneyValue = value
      this.isFocus && this.formatNumberUnit()
    },
    formatNumberUnit() {
      const { moneyValue } = this
      if (String(moneyValue).length > 2) {
        this.unitText = formatMoneyUnit(moneyValue)
      } else {
        this.unitText = ''
      }
    },
    focus(v) {
      if (this.$props.disabled || this.showDecryptWrap) return
      this.isFocus = true
      this.formatNumberUnit()
      this.$refs.inputRef.focus()
      this.$emit(eventMap.focus, v)
    },
    blur(v) {
      this.isFocus = false
      this.unitText = ''
      this.$emit(eventMap.blur, v)
      this.checkValue(this.value)
    },
    handleChange(v) {
      if (this.$props.checkValueInChangeEvent) {
        const _value = this.validateValue(v)
        if (_value !== false) {
          this.$emit(eventMap.change, _value)
        } else {
          this.$emit(eventMap.change, v)
        }
      } else {
        this.$emit(eventMap.change, v)
      }
    },
    handleInput(v) {
      this.updateMoneyValue(v)
    },
    clear() {
      this.$emit(eventMap.clear)
      this.updateMoneyValue('')
    },
    onWheel(e) {
      const { disabledStep } = this.$props
      if (disabledStep) {
        e.preventDefault()
      }
    },
    onKeydown(e) {
      const { disabledStep } = this.$props
      if (disabledStep && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
        e.preventDefault()
      }
    },
    updateMoneyValue(val) {
      if (val) val = Number(val)
      this.$emit(eventMap.input, val)
    },
    validateValue (value) {
      const { min, max, minNumberCheck } = this.$props
      // 解决用户只有值的时候做min对比
      if (minNumberCheck && value === '') return false
      if (min === -Infinity && max === Infinity) return false
      value = Number(value)
      let _value = false
      if (value > max) _value = max
      if (value < min) _value = min
      return _value
    },
    checkValue(value = this.moneyValue) {
      const _value = this.validateValue(value)
      if (_value !== false) {
        this.updateMoneyValue(_value)
      }
    },
    checkDecimal(val) {
      val = Number(val)
      if (val) {
        this.updateMoneyValue(truncateDecimals(val, this.decimal))
      }
    }
  }
}


function renderSuffix(h, props, slots) {
  if (props.showUnit) {
    return h('div',
      {
        slot: 'append',
        class: 'kye-input-money-suffix'
      },
      slots.append || props.suffixText)
  } else {
    return null
  }
}

function renderPrependText(h, props, slots) {
  if (slots.prepend || props.prependText) {
    return h('div',
      {
        slot: 'prepend',
        class: 'kye-input-money-prepend'
      },
      slots.prepend || props.prependText)
  } else {
    return null
  }
}

function renderDecryptWrap (h, vm, ElInput) {
  const { value, decryptOption = {} } = vm.$props
  return h('div', {
    class: 'kye-input-money-decrypt-wrap',
    on: {
      click: async () => {
        const val = await DECRYPT_handleDecryptAction({
          value,
          ...decryptOption,
        })
        if (val === null) {
          return
        }
        vm.$emit('input', val)
        vm.decrypting = false
      }
    }
  }, [ElInput])
}



// WEBPACK FOOTER //
// ./src/public/components/kye-input-money/input-money.js